import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import ServerSettingPage from "./server-setting-page";
 

export default (
  <Route
    path="server-settings"
    element={
      <Protected
        path="/admin/server-settings"
        roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
      >
        <ServerSettingPage />
      </Protected>
    }
  />
);



